export const normalizeStringPath = <
  Format extends 'array' | 'string' = 'array',
>(args: {
  path: string
  edgeId?: string
  includeEdge?: boolean
  includeRoot?: boolean
  format?: Format
}): Format extends 'array' ? string[] : string => {
  const {
    path,
    edgeId,
    includeEdge = true,
    includeRoot = true,
    format = 'array',
  } = args

  const pathWithEdgeId = edgeId ? `${path}/${edgeId}` : path
  let splittedPath = Array.from(
    new Set(pathWithEdgeId.split('/').filter(Boolean))
  )
  let edgeIndex = edgeId ? splittedPath.indexOf(edgeId) : -1
  if (edgeIndex !== -1) {
    // remove all the path after the edge
    splittedPath = splittedPath.slice(0, edgeIndex + 1)
  }

  if (!includeRoot) {
    splittedPath.shift()
    edgeIndex--
  }

  if (!includeEdge && edgeId) {
    splittedPath = splittedPath.filter((p) => edgeId !== p)
  }

  const applyFormat = (
    arr: string[]
  ): Format extends 'array' ? string[] : string => {
    // @ts-ignore
    if (format === 'array') return arr
    // @ts-ignore
    else return arr.join('/')
  }

  return applyFormat(splittedPath)
}
